import { extend } from 'sk-ui/lib/utils/util'

import { hasPermission } from '../../utils/permission'

import { getConfigurationWizardInfo } from '@/api'

import { asyncMenuRouterMap, constantMenuRouterMap } from '@/router'

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncMenuRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncMenuRouterMap, menus, isRouter = true) {
  const map = extend(true, [], asyncMenuRouterMap)
  let accessedRouters = map.filter(route => {
    if (menus && hasPermission(menus, route)) {
      // 具备路由菜单功能
      if (isRouter ? route.path : !isRouter) {
        if (!route.noAuth && route.children && route.children.length) {
          route.children = filterAsyncRouter(route.children, menus)
        }
        return true
      }
    }
    return false
  })
  accessedRouters.push({
    path: '*',
    name: '*',
    redirect: '/app',
    noAuth: true,
    hidden: true
  })
  return accessedRouters
}

/**
 * 递归过滤路由表，根据是否为超级管理员来控制菜单(后续权限控制具体设计以后可删除)
 */
function controlConstantRouter(constantMenuRouterMap, hasSuperPrivilege) {
  constantMenuRouterMap.map(route => {
    if (route.control) {
      route.hidden = !hasSuperPrivilege
    }

    if (route.children && route.children.length > 0) {
      controlConstantRouter(route.children, hasSuperPrivilege)
    }
  })
}

const permission = {
  state: {
    routers: constantMenuRouterMap,
    addRouters: [],
    configurationWizardVisible: false, // 是否显示配置向导
    configurationWizardStep: 0,
    isJoinUserExperiencePlan: 0, // 用户协议，加入用户体验计划
    configurationWizardUserIndex: 0 // 配置向导用户导入完成情况，完成导入用户组：1， 未完成导入用户组： 0
  },
  mutations: {
    SET_ROUTERS: (state, auth) => {
      state.addRouters = auth.routers
      state.routers = constantMenuRouterMap.concat(auth.menus)
    },
    UPDATE_MENUS: (state, menus) => {
      state.routers = menus
    },
    SET_CONFIGURATION_WIZARD_VISIBLE: (state, configurationWizardVisible = false) => {
      state.configurationWizardVisible = configurationWizardVisible
    },
    SET_CONFIGURATION_WIZARD_STEP: (state, configurationWizardStep = 0) => {
      state.configurationWizardStep = configurationWizardStep
    },
    SET_IS_JOIN_USER_EXPERIENCE_PLAN: (state, isJoinUserExperiencePlan = false) => {
      state.isJoinUserExperiencePlan = isJoinUserExperiencePlan
    },
    SET_CONFIGURATION_WIZARD_USER_INDEX: (state, configurationWizardUserIndex = 0) => {
      state.configurationWizardUserIndex = configurationWizardUserIndex
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      console.log('生成路由')
      return new Promise(resolve => {
        const { menu, hasSuperPrivilege } = data

        const accessedRouters = filterAsyncRouter(asyncMenuRouterMap, menu)

        const menus = filterAsyncRouter(asyncMenuRouterMap, menu, false)

        commit('SET_ROUTERS', { routers: accessedRouters, menus })

        // 递归过滤路由表，根据是否为超级管理员来控制菜单(后续权限控制具体设计以后可删除)
        controlConstantRouter(constantMenuRouterMap, hasSuperPrivilege)
        resolve()
      })
    },
    UpdateMenus({ commit }, data) {
      const menus = filterAsyncRouter(asyncMenuRouterMap, data, false)
      commit('UPDATE_MENUS', menus)
    },
    GetConfigurationWizardInfo({ commit }) {
      return getConfigurationWizardInfo().then(response => {
        if (response.data !== null && typeof response.data === 'object' && response.data.status === 'SUCCESS') {
          const configurationWizard = response.data.content
          const customDataArr = configurationWizard.customDataArr || []
          // 服务端接口格式限制，userIndex
          let userIndex = 0
          for (let i = 0, l = customDataArr.length; i < l; i++) {
            const item = customDataArr[i]
            if (item.key === 'userIndex') {
              userIndex = item.value || 0
              break
            }
          }
          commit('SET_CONFIGURATION_WIZARD_VISIBLE', configurationWizard.show)
          commit('SET_CONFIGURATION_WIZARD_STEP', configurationWizard.index)
          commit('SET_IS_JOIN_USER_EXPERIENCE_PLAN', configurationWizard.isJoinUserExperiencePlan)
          commit('SET_CONFIGURATION_WIZARD_USER_INDEX', userIndex)
          return response
        }
        return Promise.reject(response)
      })
    }
  },
  getters: {
    permission_routers: state => state.routers,
    addRouters: state => state.addRouters,
    configurationWizardVisible: state => state.configurationWizardVisible,
    configurationWizardStep: state => state.configurationWizardStep,
    isJoinUserExperiencePlan: state => state.isJoinUserExperiencePlan,
    configurationWizardUserIndex: state => state.configurationWizardUserIndex
  }
}

export default permission
